import { render, staticRenderFns } from "./ArticleParagraphTree.vue?vue&type=template&id=a6db1b82&"
import script from "./ArticleParagraphTree.vue?vue&type=script&lang=ts&"
export * from "./ArticleParagraphTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports